import range from "lodash/range";
import { cn } from "../../lib/utils";
import {
  Select,
  SelectValue,
  SelectContent,
  SelectItem,
  SelectTrigger,
} from "../select";
import { buttonVariants } from "../button";

export function YearNavigation({
  displayedYear,
  onChange,
  yearRange = {
    from: 1900,
    to: new Date().getFullYear(),
  },
}: {
  displayedYear: number;
  onChange: (year: number) => void;
  yearRange?: {
    from: number;
    to: number;
  };
}) {
  const years = range(yearRange.from, yearRange.to + 1);

  return (
    <Select
      value={displayedYear.toString()}
      onValueChange={(value) => onChange(parseInt(value, 10))}
    >
      <SelectTrigger
        autoFocus={false}
        onPointerDown={(e) => {
          // Prevent the click from closing the popover
          e.stopPropagation();
        }}
        className={cn(
          buttonVariants({ variant: "ghost" }),
          "w-fit h-7 border-none px-1 gap-1 font-normal bg-transparent hover:bg-accent text-muted-foreground text-base text-left justify-start"
        )}
      >
        <SelectValue placeholder={displayedYear.toString()} />
      </SelectTrigger>
      <SelectContent
        onCloseAutoFocus={(e) => {
          // Prevent focus returning to popover which would close it
          e.preventDefault();
        }}
        className="max-h-50 overflow-y-auto"
      >
        {years.map((year) => (
          <SelectItem key={year} value={year.toString()}>
            {year}
          </SelectItem>
        ))}
      </SelectContent>
    </Select>
  );
}
